<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <div class="d-flex flex-grow-1">
        <div>
          <h5 v-if="title" class="mb-0 font-weight-bolder toastification-title" v-text="title"/>
        </div>
        <span class="cursor-pointer toastification-close-icon ml-auto " @click="$emit('close-toast')">
          <feather-icon v-if="!hideClose" icon="XIcon" class="text-body"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
